import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import envelope from 'assets/img/helpdesk/ticket.png';

const TicketCreatedContent = ({ticketNo,email,onClick}) => (
  <>
       <div className="pt-5 pb-5" style={{paddingLeft:'10px',paddingRight:'10px'}}>
    <img
      className="d-block mx-auto mb-4"
      src={envelope}
      alt="sent"
      width={100}
    />
    <h3>Ticket Submitted Successfully! 🎉 </h3>
    <p>
      We have received your ticket and will respond to your inquiry as soon as possible.
     <span style={{fontSize:'20px'}}><strong>Your support ticket number is {ticketNo}</strong></span>
     {email &&  <>Please check your email <a href={email}><strong>{email}</strong></a>for further updates.</>}
     <h5>Thank you!</h5> 
    </p>
    <Button
      color="primary"
      size="sm"
      className="mt-3"
      onClick={onClick}
    >
      <FontAwesomeIcon
        icon="chevron-left"
        transform="shrink-4 down-1"
        className="me-1"
      />
      Return
    </Button>
    </div>
  </>
);

TicketCreatedContent.propTypes = {
  email: PropTypes.string.isRequired,
  layout: PropTypes.string,
  titleTag: PropTypes.string
};

TicketCreatedContent.defaultProps = { layout: 'simple', titleTag: 'h4' };

export default TicketCreatedContent;
